import APIService from './APIServices'
import type { LicenseApiItem } from '~/types/license'
export type {
    LicenseApiItem,
    LicenseRuntimeInfo,
    LicenseSerialStatusItem,
    LicenseSyncStatus,
} from '~/types/license'

export const licenseService = {
    getLicenses,
    getLicenseById,
    uploadLicense,
    deleteLicense,
}

const licenseAPI = new APIService<LicenseApiItem>('license')

async function getLicenses(): Promise<LicenseApiItem[]> {
    const data = await licenseAPI.getAll()
    return Array.isArray(data) ? data : []
}

async function deleteLicense(id: string): Promise<LicenseApiItem> {
    const response = await licenseAPI.delete(id)

    const text = await response.text()
    let result: unknown
    try {
        result = text ? JSON.parse(text) : null
    } catch {
        result = null
    }

    if (!response.ok) {
        const message =
            (result && typeof result === 'object' && result !== null && 'message' in result && typeof (result as { message: unknown }).message === 'string'
                ? (result as { message: string }).message
                : null) ?? `Failed to delete license. Status ${response.status}`
        throw new Error(message)
    }

    const payload = (result && typeof result === 'object' && result !== null && 'data' in result
        ? (result as { data: unknown }).data
        : result) as LicenseApiItem

    return payload
}

async function getLicenseById(id: string): Promise<LicenseApiItem> {
    return licenseAPI.get(id)
}

async function uploadLicense(file: File, rmType: string, description = ''): Promise<LicenseApiItem> {
    const formData = new FormData()
    formData.append('upfile', file)
    formData.append('radioManagerType', rmType)
    formData.append('description', description)
    const response = await licenseAPI.post('', formData) as unknown
    if (response && typeof response === 'object' && 'errors' in response) {
        const errors = (response as { errors?: Array<{ message?: string }> }).errors
        const message = errors?.[0]?.message || 'Unable to upload license. Please try again.'
        throw new Error(message)
    }
    if (!response || typeof response !== 'object' || !('id' in response)) {
        throw new Error('Unable to upload license. Please try again.')
    }
    return response as LicenseApiItem
}
